import {decorate, observable} from 'mobx';
import {faCog} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class LdapConnection extends BaseModel {
  static faIcon = faCog;

  static prepareApiPayload(model) {
    return {
      ...model,
      enabled: Boolean(model.enabled),
      protocol: model.protocol || '',
      host: model.host || '',
      port: model.port || 0,
      ou: model.ou || '',
      cn: model.cn || '',
      dc: model.dc || '',
    };
  }
}

decorate(LdapConnection, {
  enabled: observable,
  protocol: observable,
  host: observable,
  port: observable,
  ou: observable,
  cn: observable,
  dc: observable,
  password: observable,
});
